import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

declare let _: any;
declare let $: any;
declare let sessionStorage: any;

@Injectable({
	providedIn: 'root'
})
export class PhoneOrderSharedService  {
    enablePhoneOrder$ = new BehaviorSubject<string>("");
    onPhoneOrderEnabled$ = new BehaviorSubject<boolean>(false);
    onPhoneOrderEnabledSuccess$ = new BehaviorSubject<object>({});
    disablePhoneOrder$ = new BehaviorSubject<string>("");
    onPhoneOrderDisabled$ = new BehaviorSubject<boolean>(false);
    onPhoneOrderDisabledSuccess$ = new BehaviorSubject<object>({});
    public phoneOrderMode = false;

    /** phone order mode */
    static readonly ATTR_PHOM = 'phom';
    /** call center user's details */
    static readonly ATTR_CCUD = 'ccud';
    static readonly ATTR_PHONE_MODE_CLASS = 'phone-order-mode';

    public setPhoneOrderState(isEnabled: boolean) {
        if(isEnabled === true) {
            sessionStorage.setItem(PhoneOrderSharedService.ATTR_PHOM, String(isEnabled));
			$('body').addClass(PhoneOrderSharedService.ATTR_PHONE_MODE_CLASS);
            this.onPhoneOrderEnabled$.next(true);
        } else {
			$('body').removeClass(PhoneOrderSharedService.ATTR_PHONE_MODE_CLASS);
            this.onPhoneOrderDisabled$.next(true);
        }
    }

}